import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import messages from './local/index';

// 언어는 주소로 정해집니다: /en 으로 시작하면 영문, 그 외 국문 (src/lib/locale.ts).
// 브라우저에서는 첫 화면부터 주소 언어로 시작해야 사전 렌더링된 HTML 과 일치(hydrate)합니다.
const path = typeof window !== 'undefined' ? window.location.pathname : '/';
const initialLng = path === '/en' || path.startsWith('/en/') ? 'en' : 'ko';

i18n.use(initReactI18next).init({
  lng: initialLng,
  fallbackLng: 'ko',
  keySeparator: false,
  debug: false,
  resources: messages,
  initAsync: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
